















































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import {
  FactFindPolicyDto,
  CreatePensionCommand,
  CreatePolicyCommand,
  UpdatePolicyCommand,
  ProductProviderDto,
  PolicyBenefitTypeDTO,
  OwnerDto,
  ClientSelector,
  PolicyStatusDto,
  PolicyBasisDto,
  PolicyTypeDto,
  YesNoDefaultDto,
  PolicyBenefitDto,
  IllnessTypeDto
} from "@/api/ClientPortalApiClient";
import { LoadingSpinnerService, UserStore } from "../../store";
import ApiFactory from "../../api/ApiFactory";
import CbxYesNoDefault from "@/views/lookups/CbxYesNoDefault.vue";
import CbxProductProvider from "@/views/lookups/CbxProductProvider.vue";
import CbxPolicyStatus from "@/views/lookups/CbxPolicyStatus.vue";
import CbxPolicyType from "@/views/lookups/CbxPolicyType.vue";
import CbxPolicyBasis from "@/views/lookups/CbxPolicyBasis.vue";
import CbxIllnessType from "@/views/lookups/CbxIllnessType.vue";
import CbxBenefitType from "@/views/lookups/CbxBenefitType.vue";
import CbxOwner from "@/views/lookups/CbxOwner.vue";
import { UserStoreModule } from "../../store/users/user.store";
import AlertService from "../../services/alert.service";
import { FormatDate } from "@/filters/FormatDate";

@Component({
  components: {
    CbxOwner,
    CbxProductProvider,
    CbxYesNoDefault,
    CbxPolicyStatus,
    CbxPolicyType,
    CbxIllnessType,
    CbxBenefitType
  }
})
export default class FactFindPolicies extends Vue {
  private alertService = new AlertService();
  private contactId: number = 0;
  private displayModel = new FactFindPolicyDto();
  private emptyPolicy = new FactFindPolicyDto();
  private newBenefit = new PolicyBenefitDto();
  private selectBenefit = new PolicyBenefitDto();
  private policies: FactFindPolicyDto[] = [];
  private policyBenefits: PolicyBenefitDto[] | null = [];
  private formEnabled: boolean = false;
  private canRemoveBenefits: boolean = false;
  private mode: string = "default";
  private modelSig = "";

  public created() {
    this.contactId = parseInt(this.$route.params.contactId);
    this.loadPolicies(true);
  }

  $refs!: {
    owner: CbxOwner;
    provider: CbxProductProvider;
    indexation: CbxYesNoDefault;
    conversion: CbxYesNoDefault;
    policyStatus: CbxPolicyStatus;
    policyType: CbxPolicyType;
    benefitRole: CbxOwner;
    benefitType: CbxBenefitType;
    benefitAmount: HTMLTextAreaElement;
    mainForm: HTMLFormElement;
  };

  private savePolicy(e: Event) {
    e.preventDefault();
    if ((this.policyBenefits ? this.policyBenefits.length : 0) === 0) {
      this.alertService.error(
        "Policy Benefits Required",
        "Please add at least one benefit."
      );
      return;
    }
    if (this.mode === "update") {
      this.update();
    } else if (this.mode === "create") {
      this.createNew();
    }
    this.canRemoveBenefits = false;
  }

  private async createNew(): Promise<boolean> {
    LoadingSpinnerService.Show("Saving new Policy...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new CreatePolicyCommand();
    cmd.contactId = this.contactId;
    cmd.premium = this.displayModel.premium;
    cmd.policyNo = this.displayModel.policyNo;
    cmd.isAgencyPolicy = this.displayModel.isAgencyPolicy;
    cmd.maturityDate = FormatDate.forApi(this.displayModel.maturityDate);
    cmd.inceptionDate = FormatDate.forApi(this.displayModel.inceptionDate);

    if (this.displayModel.policyOwner) {
      cmd.policyOwner = this.displayModel.policyOwner;
    }

    if (this.displayModel.provider) {
      cmd.providerId = this.displayModel.provider.id;
    }

    if (this.displayModel.status) {
      cmd.statusId = this.displayModel.status.id;
    }

    if (this.displayModel.indexation) {
      cmd.indexedId = this.displayModel.indexation.id;
    }

    if (this.displayModel.convertible) {
      cmd.convertibleId = this.displayModel.convertible.id;
    }

    if (this.policyBenefits) {
      cmd.benefits = this.policyBenefits;
    }

    try {
      const result = await api.factFindPolicy_IndexPOST(cmd);
      this.displayModel.id = result;
      await this.loadPolicies();
      this.displayModel =
        this.policies.find(x => x.id === result) || this.displayModel;

      this.mode = "update";
      this.modelSig = JSON.stringify(this.displayModel.toJSON());
      LoadingSpinnerService.Success("Policy saved successfully");
      return true;
    } catch (e) {
      LoadingSpinnerService.Failure("Could not save Policy. Please try again.");
    }

    return false;
  }

  private async update(): Promise<boolean> {
    LoadingSpinnerService.Show("Updating Policy");
    const api = ApiFactory.CreateDataClient();
    let cmd = new UpdatePolicyCommand();

    cmd.contactId = this.contactId;
    cmd.id = this.displayModel.id;
    cmd.premium = this.displayModel.premium;
    cmd.policyNo = this.displayModel.policyNo;
    cmd.isAgencyPolicy = this.displayModel.isAgencyPolicy;
    cmd.maturityDate = FormatDate.forApi(this.displayModel.maturityDate);
    cmd.inceptionDate = FormatDate.forApi(this.displayModel.inceptionDate);

    if (this.displayModel.policyOwner) {
      cmd.policyOwner = this.displayModel.policyOwner;
    }

    if (this.displayModel.provider) {
      cmd.providerId = this.displayModel.provider.id;
    }

    if (this.displayModel.status) {
      cmd.statusId = this.displayModel.status.id;
    }

    if (this.displayModel.indexation) {
      cmd.indexedId = this.displayModel.indexation.id;
    }

    if (this.displayModel.convertible) {
      cmd.convertibleId = this.displayModel.convertible.id;
    }

    if (this.policyBenefits) {
      cmd.benefits = this.policyBenefits;
    }

    try {
      var result = await api.factFindPolicy_IndexPUT(cmd);
      if (result) {
        this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();
        LoadingSpinnerService.Success("Policy updated successfully");
        return true;
      } else {
        LoadingSpinnerService.Failure(
          "Could not update policy. Please try again."
        );
      }
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Could not update policy. Please try again."
      );
    }

    return false;
  }

  private async loadPolicies(showLoader: boolean | undefined = undefined) {
    if (showLoader) LoadingSpinnerService.Show("Loading Policies");
    const api = ApiFactory.CreateDataClient();

    try {
      const result = await api.factFindPolicy_IndexAll(this.contactId);
      this.policies = result || [];
      if (showLoader) LoadingSpinnerService.Hide();
    } catch (e) {
      this.policies = [];
      LoadingSpinnerService.Failure(
        "Could not load Policies. Please try again."
      );
    }
  }

  private async rowSelected(item: FactFindPolicyDto) {
    if (!(await this.checkForChanges())) {
      return;
    }

    this.formEnabled = true;
    this.mode = "update";
    this.displayModel = item;
    this.canRemoveBenefits = false;
    this.displayModel.inceptionDate = FormatDate.forInput(
      this.displayModel.inceptionDate
    );
    this.displayModel.maturityDate = FormatDate.forInput(
      this.displayModel.maturityDate
    );

    this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();

    if (this.displayModel.policyOwner) {
      this.$refs.owner.setSelected(this.displayModel.policyOwner);
    }

    if (this.displayModel.benefits) {
      this.policyBenefits = this.displayModel.benefits;
    }

    if (this.displayModel.provider) {
      this.$refs.provider.setSelected(this.displayModel.provider);
    }

    if (this.displayModel.status) {
      this.$refs.policyStatus.setSelected(this.displayModel.status);
    }

    if (this.displayModel.indexation) {
      this.$refs.indexation.setSelected(this.displayModel.indexation);
    }

    if (this.displayModel.convertible) {
      this.$refs.conversion.setSelected(this.displayModel.convertible);
    }
  }

  private clearData() {
    this.emptyPolicy = new FactFindPolicyDto();
    this.displayModel = this.emptyPolicy;
    this.displayModel.policyOwner = ClientSelector.Main;
    this.$refs.owner.setSelected(ClientSelector.Main);
    this.$refs.provider.setSelected(new ProductProviderDto());
    this.$refs.policyStatus.setSelected(new PolicyStatusDto());
    this.$refs.indexation.setSelected(new YesNoDefaultDto());
    this.$refs.conversion.setSelected(new YesNoDefaultDto());
  }

  public async checkForChanges(): Promise<boolean> {
    if (this.isDisplayModelEmpty() == false) {
      if (this.hasChanges() == true) {
        if (confirm("Would you like to save your changes?")) {
          return await this.saveChanges();
        }
      }
    }

    return true;
  }

  public async saveChanges(): Promise<boolean> {
    if (this.$refs.mainForm.checkValidity()) {
      if (this.mode === "update") {
        return await this.update();
      } else if (this.mode === "create") {
        return await this.createNew();
      }

      return true;
    }

    this.alertService.error(
      "Form Validation Failed",
      "Please complete all required fields"
    );
    return false;
  }

  private isDisplayModelEmpty(): boolean {
    return (
      this.mode !== "create" &&
      JSON.stringify(this.displayModel.toJSON()) ===
        JSON.stringify(this.emptyPolicy.toJSON())
    );
  }

  private hasChanges(): boolean {
    const s1 = JSON.stringify(this.displayModel.toJSON()).toString();
    if (s1 !== this.modelSig) {
      return true;
    } else {
      return false;
    }
  }

  private createClicked() {
    this.formEnabled = true;
    this.mode = "create";
    if (this.policyBenefits) this.policyBenefits = [];
    this.canRemoveBenefits = true;
    this.clearData();
  }

  private updateClicked() {
    this.formEnabled = true;
    this.mode = "update";
  }

  private addBenefitClicked(e: Event) {
    e.preventDefault();

    if (!this.policyBenefits) {
      this.policyBenefits = [];
    }
    if (
      !(this.newBenefit.benefitAmount <= 0) &&
      !(this.newBenefit.type === undefined)
    ) {
      this.policyBenefits.push(this.newBenefit);
      this.newBenefit = new PolicyBenefitDto();
      this.$refs["benefitAmount"].textContent = "";
      this.$refs.benefitRole.setSelected(ClientSelector.Main);
      this.$refs.benefitType.setSelected(new PolicyBenefitTypeDTO());
      this.newBenefit.client = ClientSelector.Main;
    } else {
      this.alertService.error(
        "Policy Benefit",
        "Insuficient Policy Benefit Details"
      );
    }
  }

  private ownerSelected(type: ClientSelector) {
    this.displayModel.policyOwner = type;
  }

  private insurerSelected(type: ProductProviderDto) {
    this.displayModel.provider = type;
  }

  private policyStatusSelected(type: PolicyStatusDto) {
    this.displayModel.status = type;
  }

  private premiumIndexedSelected(type: YesNoDefaultDto) {
    this.displayModel.indexation = type;
  }

  private conversionOptionSelected(type: YesNoDefaultDto) {
    this.displayModel.convertible = type;
  }

  private benefitRoleSelected(type: ClientSelector) {
    this.newBenefit.client = type;
  }

  private benefitTypeSelected(type: PolicyBenefitTypeDTO) {
    this.newBenefit.type = type;
  }

  private removeBenefit(benefit: number) {
    if (this.policyBenefits) {
      this.policyBenefits.splice(benefit - 1, 1);
    }
  }

  private ClientSelectorName(client: ClientSelector): string {
    return this.$refs.owner.getClientName(client);
  }
}
